import { BackgroundVideo } from '@/components/atoms/BackgroundVideo';
import React from 'react';
import { StyleSheet } from 'react-native';

const HERO_VIDEO = require('@assets/video/intro-landscape.mp4');
const HERO_PLACEHOLDER = require('@assets/images/welcome-bg.jpg');

export interface WelcomeBackgroundProps {
    children: React.ReactNode;
}

export function WelcomeBackground({ children }: WelcomeBackgroundProps) {
    return (
        <BackgroundVideo
            localSource={HERO_VIDEO}
            placeholderImage={HERO_PLACEHOLDER}
            style={styles.background}
            contentFit="cover"
            loop={true}
        >
            {children}
        </BackgroundVideo>
    );
}

const styles = StyleSheet.create({
    background: {
        ...StyleSheet.absoluteFillObject,
    },
});

export default WelcomeBackground;


